var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeartLightFilled = function SvgIconHeartLightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.116 5.508a4.273 4.273 0 0 1 3.893 1.377c.92-1.009 2.334-1.617 3.874-1.378 1.616.232 2.987 1.438 3.446 3.039.57 1.89-.187 3.431-1.267 4.522-.229.282-.939 1.014-1.744 1.832-.851.864-1.853 1.865-2.628 2.64a2.36 2.36 0 0 1-3.328 0l-.038-.038c-1.533-1.533-3.949-3.95-4.378-4.428-1.02-1.077-1.85-2.623-1.271-4.532l.005-.015C5.19 7 6.494 5.797 8.105 5.51l.011-.002Z",
    fill: "#FB4E4E"
  })));
};
export default SvgIconHeartLightFilled;